import { createContext, useContext } from 'react'

import { CommandBarItem, CommandBarOpenSource } from '../types'

export interface CommandBarContextValue {
  error?: Error
  isAvailable: boolean
  isOpen: boolean
  items: CommandBarItem[]
  loading: boolean
  openCommandBar: (source?: CommandBarOpenSource) => void
  closeCommandBar: () => void
  onQueryChange: (query: string) => void
  query: string
  runItem: (item: CommandBarItem, rank: number) => void
}

const noop = () => {}

export const defaultCommandBarContextValue: CommandBarContextValue = {
  isAvailable: false,
  isOpen: false,
  items: [],
  loading: false,
  openCommandBar: noop,
  closeCommandBar: noop,
  onQueryChange: noop,
  query: '',
  runItem: noop,
}

export const CommandBarContext = createContext<CommandBarContextValue>(
  defaultCommandBarContextValue
)

export const useCommandBar = () => useContext(CommandBarContext)

export interface CommandBarRegistrationContextValue {
  registerCommands: (key: string, commands?: CommandBarItem[]) => () => void
}

export const defaultCommandBarRegistrationContextValue: CommandBarRegistrationContextValue =
  {
    registerCommands: () => noop,
  }

export const CommandBarRegistrationContext =
  createContext<CommandBarRegistrationContextValue>(
    defaultCommandBarRegistrationContextValue
  )

export const useCommandBarRegistration = () =>
  useContext(CommandBarRegistrationContext)
